import React from 'react'

export default function PrivacyPolicy() {
    return (
        <div className='flex w-full h-full justify-center items-center mt-4 pt-8 flex-col'>
            <div className='flex w-auto h-auto mt-8 pb-8 pt-8 justify-center items-center flex-col'>
                <h2 className='text-4xl font-bold'>TenderTalk Privacy Policy</h2>
                <p className='text-lg mt-4'>TenderTalk (the “App,” “Service,” “we,” or “us”) is committed to protecting your privacy. This Privacy Policy outlines how we gather, use, disclose, and protect the data gathered via our Service, as well as what choices you have regarding the collection and use of data.</p>
                <h2 className='text-2xl font-bold mt-8'>How We Gather and Use Data</h2>
                <p className='text-lg mt-4'>We do not gather any personal data that may identify you and keep no logs. In order to start using the tracking option, we request permission to access and use your contact list. We do not store any data after tracking.</p>
                <h2 className='text-2xl font-bold mt-8'>Third-Party Services</h2>
                <p>We use third-party services (for analytic reasons in order to improve Service's performance constantly) that may gather data that may identify you. Please follow the links to the privacy policy of third-party service providers used by the Service to read more about the data that may be collected:</p>
                <ul className='list-disc ml-8 mt-4'>
                    <li className='cursor-pointer'><a href='https://policies.google.com/privacy' target='_blank' rel='noreferrer'>Google Analytics Privacy Policy</a></li>
                    <li className='cursor-pointer'><a href='https://firebase.google.com/policies/analytics' target='_blank' rel='noreferrer'>Firebase Analytics Privacy Policy</a></li>
                </ul>

                <h2 className='text-4xl font-bold mt-4' >Permission to Access Data and Usage</h2>
                <p className='text-lg mt-4'>
                    TenderTalk does not collect or use any of the user's data from their
                    TenderTalk Account for any purpose other than the proper functioning of the
                    software. By using TenderTalk, you agree to grant the necessary permissions
                    to access account in order for the software to function
                    properly. You understand and acknowledge that the software may have access
                    to all of your data on the account, but it does not collect or use any of
                    this data for any other purpose.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Cookies</h2>
                <p className='text-lg mt-4'>
                    The App does not use or collect “cookies.” However, third-party code and
                    libraries used by us may use “cookies” to gather data to improve their
                    services. You are free to opt-out cookies in your device settings.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Security</h2>
                <p className='text-lg mt-4'>
                    We appreciate your trust in giving permission to use your contacts. Thus,
                    we do our best to use commercially acceptable means for protecting your
                    data. However, you should be aware that no transmission method over the
                    Internet is 100% reliable and secure. That is why we cannot guarantee the
                    total security of the data provided.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Children’s Privacy</h2>
                <p className='text-lg mt-4'>
                    The Service is designed for users over the age of 13. We do not intend to
                    gather personally identifiable data from children under 13. If you are a
                    parent or guardian and have found out that your child has provided us with
                    personal data, please contact us as soon as possible, and we will delete
                    the data from our servers immediately.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Changes to the Policy</h2>
                <p className='text-lg mt-4'>
                    We may update the Policy from time to time. Thus, we encourage you to
                    review this page periodically to stay updated. Any changes are effective
                    right after they are posted on this page.
                </p>

                <h2 className='text-4xl font-bold mt-4'>Contacts</h2>
                <p className='text-lg mt-4 pb-8'>
                    In case you have any questions or suggestions regarding the Privacy
                    Policy, do not hesitate to contact us at
                    <a href="mailto:[MAIL]">[MAIL]</a>.
                </p>
            </div>
        </div>
    )
}
